import { faCaretUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from '@redux';
import { logout } from '@redux/auth/actions';
import { Avatar, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { UserSettingStyles } from './styles';
import {
  faArrowRightFromBracket,
  faBell,
  faGlobe,
} from '@fortawesome/pro-light-svg-icons';
import { LOCALES } from 'constants/constants';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { getAvatarByName } from 'utils/tools';
import { DynamicObjectType } from 'types/commons';

export default function UserSetting({ collapsed }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const user = useSelector<DynamicObjectType>((state) => state.auth.data);

  const [langActive, setLangActive] = useState(LOCALES[0]?.value);

  const onLogout = () => {
    dispatch(logout()).then(() => {
      navigate('/login');
    });
  };
  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div className="flex">
          <div className="w-[30px] h-[30px] rounded-[50%] overflow-hidden bg-[#8F40A3] flex justify-center items-center mr-[10px]">
            {user?.avatar ? (
              <img
                src={user.avatar}
                alt="avatar"
                className="w-[30px] h-[30px] object-cover"
              />
            ) : (
              <div className="text-[14px] text-white">
                {getAvatarByName(
                  user?.fullName || `${user?.firstName} ${user?.lastName}`,
                )}
              </div>
            )}
          </div>
          <div>
            <div className="text-[14px] font-medium text-black">
              {user?.fullName || `${user?.firstName} ${user?.lastName}`}
            </div>
            <div className="text-[12px] text-gray-500">{user?.email}</div>
          </div>
        </div>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: '2',
      label: <div onClick={onLogout}>{t('button.logout')}</div>,
      icon: <FontAwesomeIcon icon={faArrowRightFromBracket} />,
    },
    {
      key: '3',
      label: (
        <div className="footer-lang-wrap">
          {LOCALES.map((item, index) => (
            <div
              key={`lang-${index.toString()}`}
              className={
                item?.value === langActive
                  ? 'footer-lang-active'
                  : 'footer-lang'
              }
              onClick={(e) => {
                e.stopPropagation();
                setLangActive(item?.value);
              }}
            >
              {item?.value?.toUpperCase()}
            </div>
          ))}
        </div>
      ),
      icon: <FontAwesomeIcon icon={faGlobe} />,
    },
  ];
  return (
    <UserSettingStyles
      className={`d-flex space-between ${collapsed ? 'px-2.5 pb-2.5' : 'px-4 pb-4'}`}
    >
      <Dropdown
        menu={{ items }}
        placement="bottomLeft"
        arrow
        overlayClassName="footer-sidebar-avatar"
      >
        <div className="avatar-wrap pointer">
          <Avatar size={30}>
            {' '}
            {getAvatarByName(
              user?.fullName || `${user?.firstName} ${user?.lastName}`,
            )}
          </Avatar>
          <FontAwesomeIcon icon={faCaretUp} className="avatar-caret" />
        </div>
      </Dropdown>
      {!collapsed && (
        <div className="d-flex flex-center">
          <div className="pointer">
            <FontAwesomeIcon icon={faBell} className="bell-icon" />
          </div>
          <div className="help-wrap pointer">
            <FontAwesomeIcon icon={faCircleInfo} className="help-wrap-icon" />
            <p className="help-wrap-text">{t('button.help')}</p>
          </div>
        </div>
      )}
    </UserSettingStyles>
  );
}
